export default "__VITE_ASSET__MWztitYC__"